import _ from 'lodash';
import { DateTime } from 'luxon';

import type { MBCRecord } from '@appTypes/esb';
import { nonUnitTypeCodes, unitTypeCodes } from '@shared/constants';
import { getPreferredName } from '@shared/utils/preferredName';
import type { UserOrganizationInfo } from '@user/types';

export const columnsKeys = [
  'Member Id',
  'Name',
  'Gender',
  'ZipCode',
  'City',
  'State',
  'Distance',
  'Council Name',
  'Scout Count',
  'Counselor Availability',
  'Has Registration',
  'Counseled Merit Badges',
];

export type MbcSearchCsvColumns = {
  'Member Id': string;
  Name: string;
  Gender: string;
  ZipCode: string;
  City: string;
  State: string;
  Distance: string;
  'Council Name': string;
  'Scout Count': string;
  'Counselor Availability': string;
  'Has Registration': string;
  'Counseled Merit Badges': string;
};

export const formatCounselorsToCSVData = (
  foundCounselors: MBCRecord[],
): MbcSearchCsvColumns[] => {
  const flattened = foundCounselors.map(item => ({
    ...item,
    meritBadges: item.meritBadges.map(mb => mb.meritBadgeName).join(', '),
  }));

  return flattened.map(mbc => ({
    'Member Id': `${mbc.memberId}`,
    Name: getPreferredName(mbc),
    Gender: mbc.gender,
    ZipCode: mbc.zipCode,
    City: mbc.city,
    State: mbc.state,
    Distance: mbc.distance ? `${mbc.distance} mi` : '',
    'Council Name': mbc.councilName,
    'Scout Count': `${mbc.scoutCount}`,
    'Counselor Availability': mbc.counselorAvailabilityLong,
    'Has Registration': mbc.hasValidRegistration ? 'Yes' : 'No',
    'Counseled Merit Badges': mbc.meritBadges,
  }));
};
export function generateMbcCvsFilename({
  unitTypeId,
  organizationTypeId,
  organizationName,
  organizationNumber,
  acceptGender,
  councilStructureTypeId,
}: UserOrganizationInfo): string {
  const today = DateTime.local();
  const dateStr = today.toFormat('yyyyMMdd');

  const gender = acceptGender === 'Not Available' ? '' : acceptGender;
  let orgCode = '';
  let orgNumber = '';
  switch (organizationTypeId) {
    case '6':
      orgCode = unitTypeCodes[unitTypeId];
      orgNumber = organizationNumber;
      break;
    case '4':
      orgCode = nonUnitTypeCodes['C'];
      orgNumber = organizationNumber;
      break;
    case '5':
      orgCode = nonUnitTypeCodes[councilStructureTypeId];
      orgNumber = _.replace(organizationName, /\s+/g, '_');
      break;
  }

  return `${orgCode}${orgNumber}${gender}_${dateStr}_mbc`;
}
